export const samanthaBasicInteractions = [
    {
        id: 1,
        label: '(Interact...)',
        disabled: false
    },
    {
        id: 2,
        label: 'Show me tits (40$)',
        disabled: false
    },
    {
        id: 3,
        label: 'Blowjob (200$)',
        disabled: false
    },
    {
        id: 4,
        label: 'Titjob (200$)',
        disabled: false
    }
]

export const samanthaWaifuInteractions = [
    {
        id: 5,
        label: 'Show me tits',
        disabled: false
    },
    {
        id: 6,
        label: 'Date',
        disabled: false
    },
    {
        id: 7,
        label: 'Make Love',
        disabled: false
    },
    {
        id: 1,
        label: '(Interact...)',
        disabled: false
    }
]

export const samanthaSexInteractions = [
    {
        id: 8,
        label: 'Blowjob',
        disabled: false
    },
    {
        id: 9,
        label: 'Titjob',
        disabled: false
    },
]
